import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import article1 from 'assets/csdd_images/article1_img.jpeg';
import article_img_3 from 'assets/csdd_images/article_img3.jpg';
import article_img_1 from 'assets/csdd_images/about__us__pic__.jpg';
import article_img_4 from 'assets/csdd_images/article_img_4.jpg';
import article_img_5 from 'assets/csdd_images/article_img_5.jpg';

const data = [
  {
    headerImage: article_img_1,
    title:
      'Procurement Chamber trains private contractors and suppliers on accurate tender procedures',
    bodyImageAlt: 'Collection of certification from workshop',
    description:
      'The Chamber of Suppliers’ Development and Diversity (CSDD), a chamber for private contractors and suppliers of public goods and services...',
    body: (
      <MKTypography variant='subtitle1' textAlign='justify'>
        The Chamber of Suppliers’ Development and Diversity (CSDD), a chamber
        for private contractors and suppliers of public goods and services, in
        collaboration with procurement consultancy firm, ProSupp Consult, has
        organized a one-day capacity-building training on competitive tendering
        procedures for its members at the Coconut Grove Regency Hotel in Accra.
        The workshop equipped participants with the requisite documentation and
        bargaining skills to enable them secure government contracts, and to
        execute them in the manner that ensures efficiency and value for money.
        About 30 participants, comprising of practitioners, individual business
        owners and procurement professionals drawn from the construction,
        information technology, general supply and printing sectors across the
        country took part in the informative and expertise sharing session. An
        associate consultant for the chamber, Mr. Dennis Teye-Adjei, told
        journalists that the training workshop was to groom its pool of members
        to become competent and ready tenderers for government works and
        contracts.
        <br />
        <br />
        <MKBox sx={{ textAlign: 'center', mb: 1 }}>
          <img
            style={{
              borderRadius: 10,
              width: '70%',
              height: '70%',
              objectFit: 'cover',
            }}
            src={article1}
            alt='Collection of certification from workshop'
          />
        </MKBox>
        He said: “This is a chamber to empower the private sector to secure
        contracts on merit by resourcing them with the right requirements for
        government goods and services.” According to Mr. Teye-Adjei, building
        expertise in the sourcing from the public space would ensure
        competition, fairness and equal access to securing government goods and
        services. “If the private sector is capacitated to get more money, they
        can grow and diversify their business, create employment and contribute
        to national development,” he added. Facilitator for the workshop, Mr.
        Kwame Oppong, emphasizing the need for the training, highlighted that
        about 60-70percent of tenders from private suppliers do not get to the
        evaluation stage because of issues relating to improper documentation.
        “We have observed as practitioners that most contractors and suppliers
        lose out on public tenders not on the basis of pricing but the mere fact
        that their documentations do not offer the right competition.
        <br />
        <br />
        This training was to equip participants with the requisite knowledge
        about the competitive tendering procedure and how they can prepare
        tender documents to meet the expectation of clients, and ultimately
        secure government contracts for goods and services,” he said. One of the
        participants, Mrs. Dorcas Asiedu, who owns a facility management,
        fumigation and landscaping firm, Docantree Limited, told journalists
        that she was greatly empowered by the training. “This training has been
        very informational and beneficial, especially for business owners like
        myself that secure contracts through competitive tendering. Personally,
        I’ve learned that it’s all about documentation, without which one could
        have the best bid price and still not secure any contracts. I recommend
        this session to both public and private sector actors who are into
        tendering and want to become very competitive and professional,” she
        indicated. Another participant, Mrs. Dorcas Felicity Brown, who is head
        of procurement for the Greater Accra Regional Hospital, shared her
        experience, highlighting the need for professionals to constantly build
        on their capacity as procurement people. “As a practitioner, I believe
        strongly that capacity building is very important that’s why I signed up
        for this training; I’ve learned so much about the right documentation
        procedures in the bidding for public goods and services,” she noted. She
        added: “In all, it’s been an educative and open-minded session that has
        opened me up to the new things about competitive tendering and I’ll
        recommend this training to all practitioners and tenderers who want to
        build their competence in their chosen profession.”
      </MKTypography>
    ),
  },
  {
    headerImage: article_img_3,
    title: 'Effective procurement can boost economy - new GIPS President',
    bodyImageAlt: 'GIPS President, Mr. Simon Annan',
    description:
      'Effective procurement and supplier development initiatives and government policies that help SMEs to meet the needs of large industries and economies can give the economy the much-needed boost...',
    body: (
      <MKTypography variant='subtitle1' textAlign='justify'>
        Effective procurement and supplier development initiatives and
        government policies that help SMEs to meet the needs of large industries
        and economies can give the economy the much-needed boost, newly-elected
        President of Ghana Institute of Procurement and Supply (GIPS), Simon
        Annan, FGIPS, has said.
        <br />
        <br />
        Speaking to journalists shortly after assuming his new role, he said
        public procurement could be leveraged to enhance the participation of
        local industry in the single continental market, especially for small
        and medium enterprises—which make up the bulk of private sector
        businesses, and employs the majority of the country’s workforce. “Our
        economy needs a substantial boost, and we can do that through supplier
        development initiatives, intra-Africa trade, government policies, and
        the development of SMEs to meet the needs of large industries and
        economies,” he said.
        <br />
        <br />
        He explained that the Africa Continental Free Trade Area offers a range
        of opportunities, including an expansion of pooled procurement, and
        further urges African governments to adopt SME-targetted industrial
        policies that minimise the impact of their size in terms of both
        technical and financial capacity. According to the GIPS president, the
        twin crisis of COVID-19 pandemic and the Russia-Ukraine war has
        underlined the importance of the procurement practice in ensuring
        business continuity and encouraged all professionals to go about the
        duties ethically and diligently. “Our impact nationally ought to be the
        fulcrum of our operations, and we seek to help create an industrial
        economy through leadership,” he further indicated.
        <MKTypography variant='h4' textAlign='center' my={4}>
          GIPS swears in new leadership
        </MKTypography>
        GIPS, last Friday, swore in a new five-member leadership to steer the
        affairs of the institute for the next few years. The new team is led by
        procurement expert, Simon Annan, as president and assisted by Dr.
        William Oppong, vice-president; Ms. Celestine Djane, executive
        secretary; Elizabeth Odei, financial secretary; and Ebenezer Aidoo,
        organising secretary. They are mandated to promote high standard of
        integrity and accountability in the practice of procurement in the
        country, and to position procurement as the profession of choice in the
        country. Key among them, according to Mr. Annan, will be to ensure the
        passage of a Procurement Practicing Bill into law to regulate the
        procurement practice in Ghana, position and build the GIPS brand as a
        reputable professional body, increase the GIPS membership base and
        provide value to its members while facilitating partnerships with
        academia and industry within Ghana and beyond.
        <br />
        <br />
        Outgone president of GIPS, Collins Agyemang Sarpong, in his remarks,
        encouraged the new leadership to remain resolute in the quest to
        position procurement and supply chain management as a solid and
        reputable profession, and appealed to all members to give them their
        utmost support. He also charged them to build upon the several successes
        that were chalked under his leadership, including enhanced visibility,
        courting the youth and young procurement students into the fold, and the
        drafting of the Procurement Practicing Bill. GIPS Council Chair, Basil
        Ahiable, who swore in the new executives, applauded the outgoing
        leadership for their good work while tasking the new team to build a
        formidable professional body that can champion the nation’s development
        agenda. “It’s time to move to the next level by driving stakeholder
        value; we need to curb procurement-related corruption by building an
        ethical and professional procurement force to help sanitise the public
        and private procurement landscape in Ghana,” he admonished.
      </MKTypography>
    ),
  },
  {
    headerImage: article_img_4,
    title:
      'Procurement must be an elective subject at secondary schools - Education Minister advocates',
    bodyImageAlt:
      'Dr. Yaw Osei Adutwum, Education Minister, left, receiving the policy document and Procurement Practicing bill draft copy from Simon Annan, President-Ghana Institute of Procurement and Supply (GIPS), right',
    description:
      'Education Minister, Dr. Yaw Osei Adutwum, is advocating for the introduction of procurement and strategic sourcing as an elective subject in the secondary education curriculum – giving a firm foundation to students who might want to take on the profession in the latter stages of their education...',
    body: (
      <MKTypography variant='subtitle1' textAlign='justify'>
        Education Minister, Dr. Yaw Osei Adutwum, is advocating for the
        introduction of procurement and strategic sourcing as an elective
        subject in the secondary education curriculum – giving a firm foundation
        to students who might want to take on the profession in the latter
        stages of their education.
        <br />
        <br />
        He made this call when leadership of the Ghana Institute of Procurement
        and Supply (GIPS) paid a courtesy call on him to submit the policy
        document and draft copy of the Procurement Practicing bill for onward
        submission to Cabinet. The team was led by President of the Institute,
        Simon Annan. Also in attendance was Professor Douglas Boateng, one of
        world’s renowned experts on strategic sourcing and the only
        distinguished fellow of the institute.
        <br />
        <br />
        <MKBox sx={{ textAlign: 'center', mb: 1 }}>
          <img
            style={{
              borderRadius: 10,
              width: '70%',
              height: '70%',
              objectFit: 'cover',
            }}
            src={article_img_5}
            alt='Dr. Yaw Osei Adutwum, Education Minister, left, receiving the policy document and Procurement Practicing bill draft copy from Simon Annan, President-Ghana Institute of Procurement and Supply (GIPS), right'
          />
        </MKBox>
        Mr. Annan emphasised that passing the Procurement Practicing bill will
        be a game-changer, because it will provide standards, accountable
        procurement and regulations for practitioners to responsibly undertake
        their functions ethically to support Act 663 as amended. According to
        the minister, tenets of the procurement profession require discipline,
        ethical standards, a code of conduct and practical applications, which
        should be introduced to aspiring professionals at the early stages of
        their education. “The fundamental aim of this proposal is to champion
        the integration of procurement as an elective discipline within Ghana’s
        second-cycle educational framework,” the minister added. He therefore
        tasked leadership of GIPS to work with the National Council for
        Curriculum and Assessment (NaCCA) and related parties to develop the
        right course content and methodologies for implementation.
        <br />
        <br />
        President-GIPS, Simon Annan, welcomed the minister’s recommendation and
        indicated that graduates who aspire to study procurement and supply
        chain at university level after senior high school will be well-equipped
        with fundamental understanding of practical applications for
        procurement. He emphasised that studying procurement in second-cycle
        institutions will expose the citizenry to an inextricable link between
        procurement, industrialisation and sustainable job creation for
        long-term socio-economic development. “It is a good decision, because it
        supports the students to understand real applications of procurement and
        the linkages between procurement and sustainable development in the
        country,” he said.
        <br />
        <br />
        “Most people are in the procurement and supply profession by accident,
        but when it is studied as an elective course in the senior high schools
        there will be a foundation to begin from,” the GIPS president added.
        Commenting on the clarion call from the minister, Prof Boateng – former
        non-executive chairman of the Public Procurement Authority (PPA) said:
        “Without local and region wide professionalisation of procurement, Ghana
        and the rest of the continent’s long-term industrialisation and
        socio-economic development will continue to remain a pipe-dream. It is
        my hope that the Hon. Minister’s call will overwhelmingly be endorsed by
        government, CSOs and all the political parties, as it is in the nation’s
        long-term interest,” the professor concluded.
      </MKTypography>
    ),
  },
];

export default data;
